import { BACKEND_ENDPOINT } from "../utils/Common";


export async function create(req, accessToken) {
  if (!req) {
    return;
  }

  let headers = {
    'Content-Type': 'application/json', 
    'Accept': 'application/json'
  }
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }
  
  const response = await fetch(BACKEND_ENDPOINT + "feedback", {
    method: 'POST',
    body: JSON.stringify(req),
    headers: headers
  });
  if (!response.ok) {
    throw new Error(response.status);
  }
}